import React, { useState, useEffect }  from 'react';
import { DatePicker } from '@material-ui/pickers';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface FromToPickerProps {
    setDates: ({ from, to }: {from: Date; to: Date }) => void;
    reset: boolean;
}

const FromToPicker = ({ setDates, reset }: FromToPickerProps) => {
    const [dateFrom, setDateFrom] = useState<Date | null>(null);
    const [dateTo, handleDateTo] = useState<Date | null>(null);

    const [openTo, setOpenTo] = useState(false);
    const [openFrom, setOpenFrom] = useState(false);
    const { t } = useTranslation();

    const resetDates = () => {
        setDateFrom(null);
        handleDateTo(null);
    };

    useEffect(() => {
        if(reset) {
            resetDates();
        }
    }, [reset]);

    const handleDateFrom = (val: Date | null) => {
        setDateFrom(val);
        setOpenTo(true);
    };

    const closeTo = () => {
        setOpenTo(false);
    };

    const handleFromClick = () => {
        setOpenFrom(true);
    };

    const handleToClick = () => {
        if(dateFrom) {
            setOpenTo(true);
        } else {
            setOpenFrom(true);
        }

    };

    const handleClose = () => {
        setOpenFrom(false);
    };

    useEffect(() => {
        if(dateFrom && dateTo) {
            const ISOStringFrom = new Date(new Date(dateFrom).setHours(0,0,0,0)).toUTCString();
            const ISOStringTo = new Date(new Date(dateTo).setHours(23,59,59,999)).toUTCString();
            setDates({ from: new Date(ISOStringFrom), to: new Date(ISOStringTo) });
        }
    // eslint-disable-next-line
    }, [dateFrom, dateTo]);

    return (
        <Box display='flex'>
            <Box width={120}>
                <DatePicker
                    size='small'
                    autoOk
                    onReset={resetDates}
                    open={openFrom}
                    onOpen={handleFromClick}
                    // onClick={handleFromClick}
                    variant="inline"
                    inputVariant='outlined'
                    format="MM/dd/yyyy"
                    label={t('Start')}
                    value={dateFrom}
                    // @ts-ignore
                    onChange={handleDateFrom}
                    onClose={handleClose}
                />
            </Box>
            <Box width={120}>
                <DatePicker
                    size='small'
                    autoOk
                    onReset={resetDates}
                    minDate={dateFrom || undefined}
                    open={openTo}
                    variant="inline"
                    inputVariant='outlined'
                    format="MM/dd/yyyy"
                    label={t('End')}
                    onOpen={handleToClick}
                    value={dateTo}
                    // @ts-ignore
                    onChange={handleDateTo}
                    onClose={closeTo}
                />
            </Box>
        </Box>
    );
};

export default FromToPicker;
